import React, { useState, useEffect } from 'react';

import { Card, CardContent, CardHeader, Skeleton } from '@mui/material';

import ChartIcon from '@mui/icons-material/InsertChart';

import { ResponsiveLine } from '@nivo/line'

import {
  OffCanvas,
  useMessageDispatch,
} from 'itaf';

import AccessService from '../../../services/AccessService';

export default function AccessChartCanvas({ open, onCanvasClose }) {
  const [dataChart, setDataChart] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [progress, setProgress] = React.useState(0);
  const title = 'Gráfico de acessos dos ususário';

  const setMessageLocal = useMessageDispatch();
  function setMessage(message) {
    if ('parentIFrame' in window) {
      window.parentIFrame.sendMessage(message);
    }
  
    setMessageLocal(message);
  }

  useEffect(() => {
    if (open) {
      loadChart();
    }
  }, [open]);

  function loadChart() {
    setLoading(true);
    AccessService.getAccessChart()
      .then((response) => {
        setProgress(100);
        if (response.ok) {
          return response.json();
        }
        else {
          setMessage({ hasError: true, text: "Problema ao carregar gráfico. Verifique conexão de internet." });
          return null;
        }
      })
      .then((result) => {
        if (result === null) {
          return;
        }
        var data = [];
        result.map((item) => { data.push({ ...item, data: JSON.parse(item.data) })})
        setDataChart(data);
      })
      .catch ((error) => {
        console.log(error)
        setMessage({ hasError: true, text: "Problema ao carregar gráfico. Tente atualizar a tela." });
      })
      .finally (() => {
        setLoading(false);
        setProgress(0);
      });
  }
  
  const handleDrawerClose = () => {
    // setTimeout(() => { setMessage({ hasError: false, text: '' }); }, 10000);
    onCanvasClose(false);
  };

  const tooltip = ({ point }) => {
    const valueX = point?.data?.xFormatted;
    const valueY = point?.data?.yFormatted || 0;
    return (
      <div style={{
        backgroundColor: point?.seriesColor,
        color: 'white',
        fontWeight: 'bold',
        fontSize: 'inherit',
        borderRadius: '2px', 
        boxShadow: 'rgba(0, 0, 0, 0.25) 0px 1px 2px',
        padding: '5px 9px',
        display: 'max-content',
        whiteSpace: 'pre',
      }}>
        Nome: {point?.seriesId}
        <br />
        Data: {valueX}
        <br />
        Acessos: {Math.abs(valueY)}
      </div>
  )};

  return (
    <OffCanvas
      widthLg
      closeLabel="Fechar"
      showPanel={open}
      onClosedPanel={handleDrawerClose}
      isLoading={isLoading}
      header={{ title: title, add: false, edit: false, icon: (<ChartIcon />) }}
      progress={progress}
    >
        {isLoading && <Skeleton variant="rounded" width={'100%'} height={`calc(100vh - 192px)`} />}
        {!isLoading && 
          <Card sx={{ padding: 1 }}>
            <CardHeader title={'Acessos dos usários nos últimos 15 dias'} sx={{ padding: 1 }}/>
            <CardContent sx={{ width: '100%', height: `calc(100vh - 216px)` }}>
              <ResponsiveLine
                data={dataChart}
                activeLineWidth={6}
                activePointBorderWidth={3}
                activePointSize={16}
                animate={true}
                useMesh={true}
                enableTouchCrosshair={true}
                crosshairType="bottom-left"
                colors={{ scheme: 'category10' }}
                curve="monotoneX"
                lineWidth={3}
                margin={{ top: 16, right: 136, bottom: 48, left: 64 }}
                pointBorderColor={{
                  from: 'color',
                  modifiers: [
                    [
                      'darker',
                      0.3
                    ]
                  ]
                }}
                pointBorderWidth={2}
                pointSize={10}
                pointLabel="data.yFormatted"
                pointLabelYOffset={-12}
                xFormat="time:%d/%m/%Y"
                xScale={{
                  format: '%Y-%m-%d',
                  precision: 'day',
                  type: 'time',
                  useUTC: false
                }}
                axisRight={null}
                axisBottom={{
                  orient: 'bottom',
                  format: '%d/%m/%y',
                  legend: 'Dias',
                  legendOffset: 40,
                  legendPosition: 'middle',
                  tickPadding: 5,
                  tickSize: 10,
                }}
                axisLeft={{
                  tickSize: 5,
                  tickPadding: 5,
                  tickRotation: 0,
                  legend: 'Acessos',
                  legendPosition: 'middle',
                  legendOffset: -40,
                }}
                axisTop={null}
                // yFormat={(value) => value}
                yFormat=" >-.0"
                yScale={{
                  min: 0,
                  reverse: false,
                  stacked: false,
                  type: 'linear',
                  legend: 'Dias',
                  legendPosition: 'middle',
                }}
                legends={[
                  {
                    anchor: 'top-right',
                    direction: 'column',
                    justify: false,
                    translateX: 100,
                    itemsSpacing: 0,
                    itemDirection: 'left-to-right',
                    itemWidth: 80,
                    itemHeight: 22,
                    itemOpacity: 0.75,
                    symbolSize: 12,
                    symbolShape: 'circle',
                    effects: [
                      {
                        on: 'hover',
                        style: {
                          itemOpacity: 1
                        }
                      }
                    ]
                  }
                ]}
                tooltip={tooltip}
              />
            </CardContent>
          </Card>}
    </OffCanvas>
  );
};
